module.exports = __webpack_public_path__ + "static/elifsu-pinduk-e47293477350e210443af76649fa06db.webp";